import React from "react";
import about from "../../assets/images/bg2.jpg";
import { Link } from "react-router-dom";

const Aboutsection = () => {
  return (
    <>
      <div className="contact-section">
        <img src={about} alt="banner" />
        <div className="banner-contentt">
          <h1>About Us</h1>
           <p>
            <span>
              <Link to="/" className="breadcrumb-link">
                Home
              </Link>
            </span>
            /  About
          </p>
        </div>
      </div>
    </>
  );
};

export default Aboutsection;
